module.exports = __webpack_public_path__ + "img/certImg.717072d8.png";